import { AddDialogStatisticCommand, PartialListDialogStatisticDto, SortType } from '@/api-gen/api.schemas';
import type { DialogStatisticFull } from 'app/models/statistic/statistic.ts';

export enum ActionType {
  SetSelectedRowById = 'dashboard/SET_STORE_SELECTED_ROW',
  SetRow = 'dashboard/SET_ROW',
  GetDialogStatistics = 'dashboard/GET_DIALOG_STATISTICS',
  PostDialogStatistics = 'dashboard/POST_DIALOG_STATISTICS',
  PutDialogStatistics = 'dashboard/PUT_DIALOG_STATISTICS',
  SetStatisticsLoading = 'dashboard/SET_DIALOG_STATISTICS_LOADING'
}

export type PayloadType = {
  [ActionType.SetSelectedRowById]: string;
  [ActionType.SetRow]: { fullDialogStatistic?: DialogStatisticFull };
  [ActionType.PostDialogStatistics]: AddDialogStatisticCommand;
  [ActionType.GetDialogStatistics]: {
    skip: number;
    take: number;
    order: SortType;
    orderBy: string;
    from: Date;
    to: Date;
    search: string;
    selectedId?: number;
    companyName?: string;
    departmentName?: string;
    scenarioName?: string;
    userName?: string;
    durationMin?: number;
    durationMax?: number;
    scoreMin?: number;
    scoreMax?: number;
    isPhoneConversation?: boolean;
  };
  [ActionType.PutDialogStatistics]: PartialListDialogStatisticDto;
  [ActionType.SetStatisticsLoading]: boolean;
};

type SpecificPayload<T> = T extends keyof PayloadType ? (PayloadType[T] extends never ? never : PayloadType[T]) : never;

export type Action<T> = T extends keyof PayloadType
  ? {
      type: T;
    } & (SpecificPayload<T> extends void ? unknown : { payload: SpecificPayload<T> })
  : never;

type ActionCreator<T, P = SpecificPayload<T>> = T extends keyof PayloadType ? (payload: P) => Action<T> : never;

export const setRow: ActionCreator<ActionType.SetRow> = (payload) => {
  return {
    type: ActionType.SetRow,
    payload
  };
};

export const setSelectedRow: ActionCreator<ActionType.SetSelectedRowById> = (id) => {
  return {
    type: ActionType.SetSelectedRowById,
    payload: id
  };
};

export const postDialogStatistics: ActionCreator<ActionType.PostDialogStatistics> = (
  statistics: AddDialogStatisticCommand
) => {
  return {
    type: ActionType.PostDialogStatistics,
    payload: statistics
  };
};

export const getDialogStatistics: ActionCreator<ActionType.GetDialogStatistics> = (payload) => {
  return {
    type: ActionType.GetDialogStatistics,
    payload
  };
};

export const putDialogStatistics: ActionCreator<ActionType.PutDialogStatistics> = (dialogStatistics) => {
  return {
    type: ActionType.PutDialogStatistics,
    payload: dialogStatistics
  };
};

export const setStatisticsLoading: ActionCreator<ActionType.SetStatisticsLoading, boolean> = (loading) => {
  return {
    type: ActionType.SetStatisticsLoading,
    payload: loading
  };
};
